import { render, staticRenderFns } from "./DriverTeamList.vue?vue&type=template&id=35056f9e"
import script from "./DriverTeamList.vue?vue&type=script&lang=js"
export * from "./DriverTeamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports